import React from 'react';

// @context TGW-1769 @メンション補完のポップアップ表示部。候補取得・キー操作は Composer 側が持ち、
//   ここは表示専用。先頭に集合メンション（@channel、全体チャンネルのみ @everyone）、区切って個人候補。
export default function MentionAutocomplete({
  groupOptions,
  candidates,
  activeIndex,
  onSelect,
}) {
  const total = groupOptions.length + candidates.length;
  if (total === 0) return null;

  return (
    <div className="slackch-mention-popup">
      {groupOptions.map((opt, i) => (
        <button
          key={opt.key}
          type="button"
          className={`slackch-mention-row ${i === activeIndex ? 'slackch-mention-row--active' : ''}`}
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(opt);
          }}
        >
          <span className="slackch-mention-row-icon">@</span>
          <span className="slackch-mention-row-main">
            <b>{opt.label}</b>
            <small>{opt.description}</small>
          </span>
        </button>
      ))}
      {groupOptions.length > 0 && candidates.length > 0 && (
        <div className="slackch-mention-divider" />
      )}
      {candidates.map((c, i) => {
        const idx = groupOptions.length + i;
        return (
          <button
            key={c.id}
            type="button"
            className={`slackch-mention-row ${idx === activeIndex ? 'slackch-mention-row--active' : ''}`}
            onMouseDown={(e) => {
              e.preventDefault();
              onSelect(c);
            }}
          >
            {c.avatar_thumb ? (
              <img
                className="slackch-mention-row-avatar"
                src={c.avatar_thumb}
                alt=""
              />
            ) : (
              <span className="slackch-mention-row-icon">
                {(c.name || '?').charAt(0)}
              </span>
            )}
            <span className="slackch-mention-row-main">
              <b>{c.name}</b>
              {c.tunagate_id ? <small>@{c.tunagate_id}</small> : null}
            </span>
          </button>
        );
      })}
    </div>
  );
}
